import i18next from "i18next"
import { z } from "zod"

export const languages = [
  { label: "Afrikaans", value: "af" },
  { label: "Albanian", value: "sq" },
  { label: "Arabic", value: "ar" },
  { label: "Arabic (EGY)", value: "ar_EG" },
  { label: "Arabic (UAE)", value: "ar_AE" },
  { label: "Arabic (LBN)", value: "ar_LB" },
  { label: "Arabic (MAR)", value: "ar_MA" },
  { label: "Arabic (QAT)", value: "ar_QA" },
  { label: "Azerbaijani", value: "az" },
  { label: "Belarusian", value: "be_BY" },
  { label: "Bengali", value: "bn" },
  { label: "Bengali (IND)", value: "bn_IN" },
  { label: "Bulgarian", value: "bg" },
  { label: "Catalan", value: "ca_ES" },
  { label: "Chinese (CHN)", value: "zh_CN" },
  { label: "Chinese (HKG)", value: "zh_HK" },
  { label: "Chinese (TAI)", value: "zh_TW" },
  { label: "Croatian", value: "hr" },
  { label: "Czech", value: "cs_CZ" },
  { label: "Danish", value: "da_DK" },
  { label: "Dari", value: "prs_AF" },
  { label: "Dutch", value: "nl_NL" },
  { label: "Dutch (BEL)", value: "nl_BE" },
  { label: "English", value: "en" },
  { label: "English (UK)", value: "en_GB" },
  { label: "English (US)", value: "en_US" },
  { label: "English (UAE)", value: "en_AE" },
  { label: "English (AUS)", value: "en_AU" },
  { label: "English (CAN)", value: "en_CA" },
  { label: "English (GHA)", value: "en_GH" },
  { label: "English (IRL)", value: "en_IE" },
  { label: "English (IND)", value: "en_IN" },
  { label: "English (JAM)", value: "en_JM" },
  { label: "English (KEN)", value: "en_KE" },
  { label: "English (MYS)", value: "en_MY" },
  { label: "English (NZL)", value: "en_NZ" },
  { label: "English (QAT)", value: "en_QA" },
  { label: "English (SGP)", value: "en_SG" },
  { label: "English (UGA)", value: "en_UG" },
  { label: "English (ZAF)", value: "en_ZA" },
  { label: "Estonian", value: "et" },
  { label: "Euskera", value: "eu_ES" },
  { label: "Filipino", value: "fil" },
  { label: "Finnish", value: "fi_FI" },
  { label: "French", value: "fr_FR" },
  { label: "French (BEL)", value: "fr_BE" },
  { label: "French (CAN)", value: "fr_CA" },
  { label: "French (CHE)", value: "fr_CH" },
  { label: "French (CIV)", value: "fr_CI" },
  { label: "French (MAR)", value: "fr_MA" },
  { label: "Georgian", value: "ka" },
  { label: "German", value: "de_DE" },
  { label: "German (AUT)", value: "de_AT" },
  { label: "German (CHE)", value: "de_CH" },
  { label: "Greek", value: "el_GR" },
  { label: "Gujarati", value: "gu" },
  { label: "Hausa", value: "ha" },
  { label: "Hebrew", value: "he" },
  { label: "Hindi", value: "hi_IN" },
  { label: "Hungarian", value: "hu" },
  { label: "Indonesian", value: "id" },
  { label: "Irish", value: "ga" },
  { label: "Italian", value: "it_IT" },
  { label: "Japanese", value: "ja" },
  { label: "Kannada", value: "kn" },
  { label: "Kazakh", value: "kk" },
  { label: "Kinyarwanda", value: "rw_RW" },
  { label: "Korean", value: "ko" },
  { label: "Kyrgyz (Kyrgyzstan)", value: "ky_KG" },
  { label: "Lao", value: "lo" },
  { label: "Latvian", value: "lv_LV" },
  { label: "Lithuanian", value: "lt_LT" },
  { label: "Macedonian", value: "mk_MK" },
  { label: "Malay", value: "ms_MY" },
  { label: "Malayalam", value: "ml_IN" },
  { label: "Marathi", value: "mr_IN" },
  { label: "Norwegian", value: "nb_NO" },
  { label: "Pashto", value: "ps_AF" },
  { label: "Persian", value: "fa_IR" },
  { label: "Polish", value: "pl_PL" },
  { label: "Portuguese (BR)", value: "pt_BR" },
  { label: "Portuguese (POR)", value: "pt_PT" },
  { label: "Punjabi", value: "pa" },
  { label: "Romanian", value: "ro_RO" },
  { label: "Russian", value: "ru" },
  { label: "Serbian", value: "sr" },
  { label: "Sinhala", value: "si_LK" },
  { label: "Slovak", value: "sk" },
  { label: "Slovenian", value: "sl" },
  { label: "Spanish", value: "es" },
  { label: "Spanish (ARG)", value: "es_AR" },
  { label: "Spanish (CHL)", value: "es_CL" },
  { label: "Spanish (COL)", value: "es_CO" },
  { label: "Spanish (CRI)", value: "es_CR" },
  { label: "Spanish (DOM)", value: "es_DO" },
  { label: "Spanish (ECU)", value: "es_EC" },
  { label: "Spanish (HND)", value: "es_HN" },
  { label: "Spanish (MEX)", value: "es_MX" },
  { label: "Spanish (PAN)", value: "es_PA" },
  { label: "Spanish (PER)", value: "es_PE" },
  { label: "Spanish (SPA)", value: "es_ES" },
  { label: "Spanish (URY)", value: "es_UY" },
  { label: "Swahili", value: "sw" },
  { label: "Swedish", value: "sv" },
  { label: "Tamil", value: "ta" },
  { label: "Telugu", value: "te" },
  { label: "Thai", value: "th" },
  { label: "Turkish", value: "tr_TR" },
  { label: "Ukrainian", value: "uk" },
  { label: "Urdu", value: "ur_PK" },
  { label: "Uzbek", value: "uz" },
  { label: "Vietnamese", value: "vi" },
  { label: "Zulu", value: "zu" },
] as const

export const whatsappLanguages = [
  { label: "Arabic", value: "ar" },
  { label: "Catalan", value: "ca" },
  { label: "Croatian", value: "hr" },
  { label: "Czech", value: "cs" },
  { label: "Dutch", value: "nl" },
  { label: "English", value: "en" },
  { label: "Finnish", value: "fi" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Greek", value: "el" },
  { label: "Hindi", value: "hi" },
  { label: "Italian", value: "it" },
  { label: "Latvian", value: "lv" },
  { label: "Lithuanian", value: "lt" },
  { label: "Polish", value: "pl" },
  { label: "Portuguese", value: "pt_PT" },
  { label: "Romanian", value: "ro" },
  { label: "Slovenian", value: "sl" },
  { label: "Spanish", value: "es" },
  { label: "Swahili", value: "sw" },
  { label: "Turkish", value: "tr" },
  { label: "Urdu", value: "ur" },
]

export const whatsappLanguagesMap = new Map(
  whatsappLanguages.map((language) => [language.value, language]),
)

export const LocaleEnum = z.enum(languages.map((lang) => lang.value) as [string, ...string[]])

export const LanguageMap = new Map(languages.map((language) => [language.value, language]))

export type LanguageMapKeys = (typeof languages)[number]["value"]

export const getLanguageLabel = (locale: string | null | undefined) =>
  LanguageMap.get(locale as LanguageMapKeys)?.label ?? "English"

export const LanguageEnum = [...languages, ...whatsappLanguages].reduce(
  (acc, language) => {
    acc[language.value] = language.label
    return acc
  },
  {} as Record<
    (typeof languages)[number]["value"] | (typeof whatsappLanguages)[number]["value"],
    string
  >,
)

export const countryLanguageMap: Record<string, string[]> = {
  // English-speaking countries
  us: ["en", "en-US"],
  gb: ["en", "en-GB"],
  ca: ["en", "en-CA", "fr", "fr-CA"],
  au: ["en", "en-AU"],
  nz: ["en", "en-NZ"],
  ie: ["en", "en-IE"],
  za: ["en", "en-ZA", "af", "zu", "xh"],

  // Spanish-speaking countries
  es: ["es", "es-ES"],
  mx: ["es", "es-MX"],
  ar: ["es", "es-AR"],
  co: ["es", "es-CO"],
  pe: ["es", "es-PE"],
  ve: ["es", "es-VE"],
  cl: ["es", "es-CL"],
  ec: ["es", "es-EC"],
  gt: ["es", "es-GT"],
  cu: ["es", "es-CU"],
  bo: ["es", "es-BO"],
  do: ["es", "es-DO"],
  hn: ["es", "es-HN"],
  py: ["es", "es-PY"],
  sv: ["es", "es-SV"],
  ni: ["es", "es-NI"],
  cr: ["es", "es-CR"],
  pa: ["es", "es-PA"],
  uy: ["es", "es-UY"],
  gq: ["es", "es-GQ"],

  // French-speaking countries
  fr: ["fr", "fr-FR"],
  be: ["fr", "fr-BE", "nl", "nl-BE", "de", "de-BE"],
  ch: ["fr", "fr-CH", "de", "de-CH", "it", "it-CH"],
  lu: ["fr", "fr-LU", "de", "de-LU", "lb"],
  mc: ["fr", "fr-MC"],
  cd: ["fr", "fr-CD"],
  mg: ["fr", "fr-MG"],
  cm: ["fr", "fr-CM"],
  ci: ["fr", "fr-CI"],
  bf: ["fr", "fr-BF"],
  ne: ["fr", "fr-NE"],
  sn: ["fr", "fr-SN"],
  ml: ["fr", "fr-ML"],
  rw: ["fr", "fr-RW"],
  td: ["fr", "fr-TD"],

  // German-speaking countries
  de: ["de", "de-DE"],
  at: ["de", "de-AT"],
  li: ["de", "de-LI"],

  // Portuguese-speaking countries
  pt: ["pt", "pt-PT"],
  br: ["pt", "pt-BR"],
  ao: ["pt", "pt-AO"],
  mz: ["pt", "pt-MZ"],
  gw: ["pt", "pt-GW"],
  cv: ["pt", "pt-CV"],
  st: ["pt", "pt-ST"],
  tl: ["pt", "pt-TL"],

  // Italian-speaking countries
  it: ["it", "it-IT"],
  sm: ["it", "it-SM"],
  va: ["it", "it-VA"],

  // Dutch-speaking countries
  nl: ["nl", "nl-NL"],
  sr: ["nl", "nl-SR"],

  // Nordic countries
  no: ["no", "nb", "nn"],
  se: ["sv", "sv-SE"],
  dk: ["da", "da-DK"],
  fi: ["fi", "fi-FI", "sv", "sv-FI"],
  is: ["is", "is-IS"],

  // Slavic countries
  pl: ["pl", "pl-PL"],
  cz: ["cs", "cs-CZ"],
  sk: ["sk", "sk-SK"],
  si: ["sl", "sl-SI"],
  hr: ["hr", "hr-HR"],
  rs: ["sr", "sr-RS"],
  bg: ["bg", "bg-BG"],
  mk: ["mk", "mk-MK"],
  ba: ["bs", "hr", "sr"],
  me: ["sr", "me"],

  // Eastern Europe
  ru: ["ru", "ru-RU"],
  ua: ["uk", "uk-UA", "ru"],
  by: ["be", "ru"],
  md: ["ro", "ru"],
  ro: ["ro", "ro-RO"],
  hu: ["hu", "hu-HU"],

  // Baltic countries
  lt: ["lt", "lt-LT"],
  lv: ["lv", "lv-LV"],
  ee: ["et", "et-EE"],

  // Asian countries
  jp: ["ja", "ja-JP"],
  kr: ["ko", "ko-KR"],
  cn: ["zh", "zh-CN"],
  tw: ["zh", "zh-TW"],
  hk: ["zh", "zh-HK", "en"],
  sg: ["en", "zh", "ms", "ta"],
  my: ["ms", "en", "zh"],
  th: ["th", "th-TH"],
  vn: ["vi", "vi-VN"],
  id: ["id", "id-ID"],
  ph: ["en", "tl"],
  in: ["hi", "en", "bn", "te", "mr", "ta", "ur", "gu", "kn", "ml", "or", "pa"],

  // Middle East
  sa: ["ar", "ar-SA"],
  ae: ["ar", "ar-AE", "en"],
  qa: ["ar", "ar-QA", "en"],
  kw: ["ar", "ar-KW"],
  bh: ["ar", "ar-BH", "en"],
  om: ["ar", "ar-OM"],
  jo: ["ar", "ar-JO"],
  lb: ["ar", "ar-LB", "fr"],
  sy: ["ar", "ar-SY"],
  iq: ["ar", "ar-IQ"],
  ye: ["ar", "ar-YE"],
  il: ["he", "he-IL", "ar"],
  tr: ["tr", "tr-TR"],
  ir: ["fa", "fa-IR"],

  // Africa
  eg: ["ar", "ar-EG"],
  ma: ["ar", "ar-MA", "fr"],
  dz: ["ar", "ar-DZ", "fr"],
  tn: ["ar", "ar-TN", "fr"],
  ly: ["ar", "ar-LY"],
  ng: ["en", "ha", "ig", "yo"],
  ke: ["sw", "en"],
  et: ["am", "en"],
  gh: ["en", "tw"],

  // Others
  gr: ["el", "el-GR"],
  mt: ["mt", "en"],
  cy: ["el", "tr", "en"],
  al: ["sq", "sq-AL"],
}

export const translateKey = (key: string, locale: string) => {
  if (!i18next.exists(key, { lng: locale })) return undefined
  return i18next.t(key, { lng: locale })
}

const LOCALE_PATTERN = /^([a-z]{2,3})(?:[-_]([a-z]{2}|\d{3}))?(?:[-_]|$)/i

// Canonical customer locale: "es", "es_ES" or "es_419". Unparseable values return undefined so
// they never overwrite a stored locale.
export function normalizeLocale(locale: string | null | undefined) {
  if (locale === null) return null

  const [, language, region] = locale?.trim().match(LOCALE_PATTERN) ?? []
  if (!language) return undefined

  return region ? `${language.toLowerCase()}_${region.toUpperCase()}` : language.toLowerCase()
}
